<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="events"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :date="date"
      :externalFilters="externalFilters"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">События</h1>
        <btn-filters
          :data="data"
          endpoint="events"
          v-model="filtersValue"
          :range="true"
          :date.sync="date"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        @sort-change="sortChange"
        @load-more="loadMore"
        :hasMore="hasMore"
        :loading="loading"
        @filter-change="refreshFilters"
      >
        <el-table-column v-if="$root.isAdmin()"
          type="expand">
          <template slot-scope="{row}">
            <div class="event-details-expand">
              <event-details :event="row"></event-details>
            </div>
          </template>
        </el-table-column>
        <table-column-serial-number prop="machine.serial_number" machine-prop="machine"/>
        <el-table-column
          prop="machine.address"
          label="Адрес установки"
          :show-overflow-tooltip="true"
          min-width="300"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="Тип события"
          min-width="200"
          :filters="codeFilters"
          filter-placement="bottom-start"
        >
        <template slot-scope="{row}">{{ row.message }}</template>
        </el-table-column>
        <table-column-date/>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import sortBy from 'lodash/sortBy'
  import events from '../../../lang/events.json'

  export default {
    metaInfo: {title: 'События'},
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        sort: null,
        date: {
          min: null,
          max: null,
        },
        externalFilters: null,
      }
    },
    methods: {
      loadMore () {
        this.$refs.data.loadMore()
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.$emit('update:sort', `${sort.prop}:${order}`)
        } else {
          this.$emit('update:sort', null)
        }
      },
      refreshFilters (event) {
        this.externalFilters = Object.values(event)
      },
    },
    computed: {
      codeFilters () {
        return sortBy(Object.entries(events).map(([key, value]) => {
          return {
            value: key,
            text: value.split('|')[0],
          }
        }), 'text')
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .event-details-expand .event-data-result {
    max-height: 29.5 * $line-height-base * 1em;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/events/index.vue